exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "/* The section wrapper is a flex column, so Main has to flex too or the embedded\n   iframe collapses to its min-height. */\n.xYKpVDHOz8vTH-LELj2O2 {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-height: 0;\n}\n", ""]);

// Exports
exports.locals = {
	"page": "xYKpVDHOz8vTH-LELj2O2"
};